// Generated from Unicode Unihan kTotalStrokes. Do not edit by hand.
export const characterStrokeCounts: Readonly<Record<string, number>> = {
  "一": 1,
  "乙": 1,
  "丁": 2,
  "七": 2,
  "乃": 2,
  "九": 2,
  "了": 2,
  "二": 2,
  "人": 2,
  "儿": 2,
  "入": 2,
  "八": 2,
  "几": 2,
  "刀": 2,
  "力": 2,
  "十": 2,
  "卜": 2,
  "又": 2,
  "万": 3,
  "丈": 3,
  "三": 3,
  "上": 3,
  "下": 3,
  "与": 3,
  "个": 3,
  "久": 3,
  "么": 3,
  "义": 3,
  "也": 3,
  "习": 3,
  "于": 3,
  "亏": 3,
  "亿": 3,
  "凡": 3,
  "千": 3,
  "卫": 3,
  "叉": 3,
  "口": 3,
  "土": 3,
  "士": 3,
  "夕": 3,
  "大": 3,
  "女": 3,
  "子": 3,
  "寸": 3,
  "小": 3,
  "尸": 3,
  "山": 3,
  "川": 3,
  "工": 3,
  "己": 3,
  "已": 3,
  "巾": 3,
  "干": 3,
  "广": 3,
  "弓": 3,
  "才": 3,
  "门": 3,
  "飞": 3,
  "马": 3,
  "不": 4,
  "丑": 4,
  "专": 4,
  "中": 4,
  "丰": 4,
  "丹": 4,
  "为": 4,
  "之": 4,
  "乌": 4,
  "书": 4,
  "云": 4,
  "五": 4,
  "井": 4,
  "什": 4,
  "仁": 4,
  "仅": 4,
  "仆": 4,
  "仇": 4,
  "今": 4,
  "仍": 4,
  "从": 4,
  "仑": 4,
  "仓": 4,
  "允": 4,
  "元": 4,
  "公": 4,
  "六": 4,
  "内": 4,
  "冈": 4,
  "凤": 4,
  "凶": 4,
  "分": 4,
  "切": 4,
  "劝": 4,
  "办": 4,
  "勾": 4,
  "化": 4,
  "匹": 4,
  "区": 4,
  "午": 4,
  "厅": 4,
  "历": 4,
  "及": 4,
  "友": 4,
  "双": 4,
  "反": 4,
  "天": 4,
  "太": 4,
  "夫": 4,
  "孔": 4,
  "少": 4,
  "尤": 4,
  "尺": 4,
  "巴": 4,
  "币": 4,
  "幻": 4,
  "开": 4,
  "引": 4,
  "心": 4,
  "忆": 4,
  "戈": 4,
  "手": 4,
  "扎": 4,
  "支": 4,
  "文": 4,
  "斗": 4,
  "斤": 4,
  "方": 4,
  "无": 4,
  "日": 4,
  "曰": 4,
  "月": 4,
  "木": 4,
  "欠": 4,
  "止": 4,
  "比": 4,
  "毛": 4,
  "氏": 4,
  "气": 4,
  "水": 4,
  "火": 4,
  "父": 4,
  "片": 4,
  "牛": 4,
  "王": 4,
  "见": 4,
  "计": 4,
  "订": 4,
  "认": 4,
  "贝": 4,
  "车": 4,
  "长": 4,
  "韦": 4,
  "风": 4,
  "且": 5,
  "世": 5,
  "丘": 5,
  "业": 5,
  "丛": 5,
  "东": 5,
  "丝": 5,
  "主": 5,
  "乎": 5,
  "乏": 5,
  "乐": 5,
  "仔": 5,
  "他": 5,
  "仗": 5,
  "仙": 5,
  "代": 5,
  "令": 5,
  "以": 5,
  "仪": 5,
  "们": 5,
  "兄": 5,
  "兰": 5,
  "册": 5,
  "写": 5,
  "冬": 5,
  "冯": 5,
  "出": 5,
  "击": 5,
  "刊": 5,
  "功": 5,
  "加": 5,
  "包": 5,
  "匆": 5,
  "北": 5,
  "半": 5,
  "卢": 5,
  "厉": 5,
  "去": 5,
  "发": 5,
  "古": 5,
  "另": 5,
  "只": 5,
  "叫": 5,
  "召": 5,
  "可": 5,
  "台": 5,
  "史": 5,
  "右": 5,
  "号": 5,
  "司": 5,
  "叹": 5,
  "四": 5,
  "处": 5,
  "外": 5,
  "失": 5,
  "头": 5,
  "奴": 5,
  "奶": 5,
  "孕": 5,
  "宁": 5,
  "它": 5,
  "对": 5,
  "尔": 5,
  "尼": 5,
  "左": 5,
  "巧": 5,
  "市": 5,
  "布": 5,
  "帅": 5,
  "平": 5,
  "幼": 5,
  "弗": 5,
  "必": 5,
  "扑": 5,
  "打": 5,
  "扔": 5,
  "斥": 5,
  "旦": 5,
  "未": 5,
  "末": 5,
  "本": 5,
  "术": 5,
  "正": 5,
  "母": 5,
  "民": 5,
  "汇": 5,
  "玄": 5,
  "瓜": 5,
  "瓦": 5,
  "甘": 5,
  "生": 5,
  "用": 5,
  "由": 5,
  "甲": 5,
  "申": 5,
  "电": 5,
  "白": 5,
  "目": 5,
  "矛": 5,
  "石": 5,
  "示": 5,
  "穴": 5,
  "立": 5,
  "纠": 5,
  "让": 5,
  "训": 5,
  "议": 5,
  "讯": 5,
  "记": 5,
  "辽": 5,
  "邓": 5,
  "闪": 5,
  "队": 5,
  "饥": 5,
  "鸟": 5,
  "龙": 5,
  "丢": 6,
  "乔": 6,
  "争": 6,
  "亚": 6,
  "交": 6,
  "产": 6,
  "仰": 6,
  "仲": 6,
  "件": 6,
  "价": 6,
  "任": 6,
  "仿": 6,
  "企": 6,
  "伍": 6,
  "伏": 6,
  "伐": 6,
  "休": 6,
  "众": 6,
  "伙": 6,
  "会": 6,
  "伞": 6,
  "伟": 6,
  "传": 6,
  "伤": 6,
  "伪": 6,
  "似": 6,
  "充": 6,
  "兆": 6,
  "先": 6,
  "光": 6,
  "全": 6,
  "共": 6,
  "关": 6,
  "兴": 6,
  "再": 6,
  "军": 6,
  "农": 6,
  "冰": 6,
  "决": 6,
  "刑": 6,
  "划": 6,
  "列": 6,
  "则": 6,
  "刚": 6,
  "创": 6,
  "务": 6,
  "劣": 6,
  "动": 6,
  "匠": 6,
  "华": 6,
  "印": 6,
  "厌": 6,
  "吁": 6,
  "吃": 6,
  "各": 6,
  "合": 6,
  "吊": 6,
  "同": 6,
  "名": 6,
  "后": 6,
  "吐": 6,
  "向": 6,
  "吓": 6,
  "吕": 6,
  "吗": 6,
  "回": 6,
  "因": 6,
  "团": 6,
  "在": 6,
  "地": 6,
  "圳": 6,
  "场": 6,
  "壮": 6,
  "多": 6,
  "夸": 6,
  "夹": 6,
  "夺": 6,
  "奸": 6,
  "她": 6,
  "好": 6,
  "如": 6,
  "妄": 6,
  "字": 6,
  "存": 6,
  "宅": 6,
  "宇": 6,
  "安": 6,
  "寺": 6,
  "导": 6,
  "尖": 6,
  "尘": 6,
  "尽": 6,
  "岂": 6,
  "巡": 6,
  "师": 6,
  "年": 6,
  "并": 6,
  "庄": 6,
  "庆": 6,
  "式": 6,
  "当": 6,
  "戏": 6,
  "扣": 6,
  "扩": 6,
  "扫": 6,
  "扬": 6,
  "收": 6,
  "旨": 6,
  "早": 6,
  "曲": 6,
  "有": 6,
  "朱": 6,
  "朴": 6,
  "朵": 6,
  "机": 6,
  "杀": 6,
  "权": 6,
  "次": 6,
  "欢": 6,
  "此": 6,
  "死": 6,
  "毕": 6,
  "汗": 6,
  "江": 6,
  "池": 6,
  "污": 6,
  "汤": 6,
  "灯": 6,
  "灰": 6,
  "爷": 6,
  "玑": 6,
  "百": 6,
  "竹": 6,
  "米": 6,
  "红": 6,
  "纤": 6,
  "约": 6,
  "级": 6,
  "纪": 6,
  "网": 6,
  "羊": 6,
  "羽": 6,
  "老": 6,
  "考": 6,
  "而": 6,
  "肉": 6,
  "肌": 6,
  "臣": 6,
  "自": 6,
  "至": 6,
  "舌": 6,
  "舟": 6,
  "色": 6,
  "艾": 6,
  "节": 6,
  "芝": 6,
  "虫": 6,
  "血": 6,
  "行": 6,
  "西": 6,
  "观": 6,
  "讲": 6,
  "讶": 6,
  "许": 6,
  "论": 6,
  "讼": 6,
  "设": 6,
  "访": 6,
  "负": 6,
  "轨": 6,
  "边": 6,
  "闭": 6,
  "问": 6,
  "闯": 6,
  "阳": 6,
  "页": 6,
  "驰": 6,
  "齐": 6,
  "两": 7,
  "严": 7,
  "串": 7,
  "亨": 7,
  "估": 7,
  "伴": 7,
  "伸": 7,
  "但": 7,
  "位": 7,
  "低": 7,
  "住": 7,
  "佐": 7,
  "体": 7,
  "何": 7,
  "作": 7,
  "你": 7,
  "克": 7,
  "兵": 7,
  "况": 7,
  "冻": 7,
  "利": 7,
  "别": 7,
  "助": 7,
  "努": 7,
  "劫": 7,
  "励": 7,
  "劲": 7,
  "医": 7,
  "即": 7,
  "却": 7,
  "卵": 7,
  "吞": 7,
  "吟": 7,
  "否": 7,
  "吧": 7,
  "吨": 7,
  "吩": 7,
  "听": 7,
  "启": 7,
  "吴": 7,
  "吵": 7,
  "吹": 7,
  "吻": 7,
  "吼": 7,
  "吾": 7,
  "呆": 7,
  "呈": 7,
  "告": 7,
  "员": 7,
  "围": 7,
  "址": 7,
  "坐": 7,
  "坑": 7,
  "坛": 7,
  "坠": 7,
  "声": 7,
  "妖": 7,
  "妙": 7,
  "妥": 7,
  "妨": 7,
  "姊": 7,
  "孝": 7,
  "完": 7,
  "宏": 7,
  "寿": 7,
  "尾": 7,
  "尿": 7,
  "局": 7,
  "屁": 7,
  "层": 7,
  "岗": 7,
  "巫": 7,
  "希": 7,
  "帐": 7,
  "床": 7,
  "库": 7,
  "应": 7,
  "廷": 7,
  "弃": 7,
  "弄": 7,
  "张": 7,
  "形": 7,
  "役": 7,
  "彻": 7,
  "忌": 7,
  "忍": 7,
  "志": 7,
  "忘": 7,
  "忧": 7,
  "快": 7,
  "成": 7,
  "我": 7,
  "戒": 7,
  "扭": 7,
  "扮": 7,
  "扯": 7,
  "扰": 7,
  "扶": 7,
  "批": 7,
  "找": 7,
  "技": 7,
  "抄": 7,
  "把": 7,
  "抑": 7,
  "投": 7,
  "抖": 7,
  "折": 7,
  "抚": 7,
  "抛": 7,
  "抢": 7,
  "护": 7,
  "报": 7,
  "拒": 7,
  "拟": 7,
  "改": 7,
  "攻": 7,
  "时": 7,
  "更": 7,
  "杆": 7,
  "李": 7,
  "杜": 7,
  "条": 7,
  "来": 7,
  "杨": 7,
  "极": 7,
  "步": 7,
  "歼": 7,
  "每": 7,
  "求": 7,
  "汪": 7,
  "汽": 7,
  "沃": 7,
  "沈": 7,
  "沟": 7,
  "没": 7,
  "泛": 7,
  "灾": 7,
  "牢": 7,
  "状": 7,
  "犹": 7,
  "狂": 7,
  "狄": 7,
  "玛": 7,
  "甫": 7,
  "男": 7,
  "盯": 7,
  "矣": 7,
  "秀": 7,
  "私": 7,
  "究": 7,
  "穷": 7,
  "系": 7,
  "纯": 7,
  "纲": 7,
  "纳": 7,
  "纵": 7,
  "纷": 7,
  "纸": 7,
  "纹": 7,
  "纽": 7,
  "罕": 7,
  "肖": 7,
  "肚": 7,
  "肝": 7,
  "肠": 7,
  "芒": 7,
  "苍": 7,
  "言": 7,
  "证": 7,
  "识": 7,
  "诉": 7,
  "诊": 7,
  "译": 7,
  "谷": 7,
  "豆": 7,
  "贡": 7,
  "财": 7,
  "赤": 7,
  "走": 7,
  "足": 7,
  "身": 7,
  "辛": 7,
  "达": 7,
  "迁": 7,
  "迅": 7,
  "过": 7,
  "迈": 7,
  "运": 7,
  "返": 7,
  "进": 7,
  "远": 7,
  "违": 7,
  "迟": 7,
  "那": 7,
  "邦": 7,
  "邪": 7,
  "邮": 7,
  "邻": 7,
  "里": 7,
  "针": 7,
  "钉": 7,
  "闲": 7,
  "间": 7,
  "闷": 7,
  "防": 7,
  "阻": 7,
  "陀": 7,
  "际": 7,
  "陆": 7,
  "饮": 7,
  "驱": 7,
  "驳": 7,
  "鸡": 7,
  "麦": 7,
  "丧": 8,
  "乳": 8,
  "事": 8,
  "些": 8,
  "享": 8,
  "京": 8,
  "佩": 8,
  "佳": 8,
  "使": 8,
  "例": 8,
  "侍": 8,
  "供": 8,
  "依": 8,
  "侠": 8,
  "侦": 8,
  "侧": 8,
  "其": 8,
  "具": 8,
  "典": 8,
  "净": 8,
  "凭": 8,
  "凯": 8,
  "函": 8,
  "初": 8,
  "到": 8,
  "制": 8,
  "刷": 8,
  "券": 8,
  "刹": 8,
  "刺": 8,
  "刻": 8,
  "剂": 8,
  "劳": 8,
  "势": 8,
  "卑": 8,
  "卓": 8,
  "单": 8,
  "卧": 8,
  "卷": 8,
  "参": 8,
  "叔": 8,
  "取": 8,
  "受": 8,
  "变": 8,
  "呢": 8,
  "周": 8,
  "呵": 8,
  "命": 8,
  "和": 8,
  "咐": 8,
  "咒": 8,
  "哎": 8,
  "国": 8,
  "图": 8,
  "坡": 8,
  "坦": 8,
  "垂": 8,
  "壳": 8,
  "备": 8,
  "夜": 8,
  "奇": 8,
  "奈": 8,
  "奉": 8,
  "奋": 8,
  "奔": 8,
  "妮": 8,
  "妹": 8,
  "妻": 8,
  "姆": 8,
  "始": 8,
  "姓": 8,
  "委": 8,
  "孟": 8,
  "季": 8,
  "孤": 8,
  "学": 8,
  "官": 8,
  "宙": 8,
  "定": 8,
  "宜": 8,
  "实": 8,
  "居": 8,
  "屈": 8,
  "届": 8,
  "岩": 8,
  "岭": 8,
  "岳": 8,
  "帕": 8,
  "底": 8,
  "店": 8,
  "庙": 8,
  "府": 8,
  "庞": 8,
  "废": 8,
  "延": 8,
  "弥": 8,
  "弦": 8,
  "彼": 8,
  "往": 8,
  "径": 8,
  "忠": 8,
  "念": 8,
  "态": 8,
  "怔": 8,
  "怕": 8,
  "怖": 8,
  "怜": 8,
  "性": 8,
  "或": 8,
  "房": 8,
  "所": 8,
  "承": 8,
  "披": 8,
  "抬": 8,
  "抱": 8,
  "抵": 8,
  "抹": 8,
  "押": 8,
  "抽": 8,
  "拆": 8,
  "拉": 8,
  "拍": 8,
  "拐": 8,
  "拓": 8,
  "拔": 8,
  "拖": 8,
  "拘": 8,
  "拥": 8,
  "拦": 8,
  "拨": 8,
  "放": 8,
  "旺": 8,
  "昂": 8,
  "昆": 8,
  "昌": 8,
  "明": 8,
  "昏": 8,
  "易": 8,
  "服": 8,
  "杯": 8,
  "杰": 8,
  "构": 8,
  "析": 8,
  "林": 8,
  "枚": 8,
  "果": 8,
  "枝": 8,
  "柜": 8,
  "欣": 8,
  "武": 8,
  "歧": 8,
  "氛": 8,
  "河": 8,
  "治": 8,
  "沿": 8,
  "泄": 8,
  "泊": 8,
  "法": 8,
  "泡": 8,
  "波": 8,
  "泥": 8,
  "注": 8,
  "泪": 8,
  "浅": 8,
  "炉": 8,
  "炎": 8,
  "爬": 8,
  "爸": 8,
  "牧": 8,
  "物": 8,
  "狗": 8,
  "玩": 8,
  "玫": 8,
  "环": 8,
  "现": 8,
  "畅": 8,
  "的": 8,
  "盲": 8,
  "直": 8,
  "知": 8,
  "矿": 8,
  "码": 8,
  "社": 8,
  "空": 8,
  "线": 8,
  "练": 8,
  "组": 8,
  "细": 8,
  "织": 8,
  "终": 8,
  "绍": 8,
  "经": 8,
  "罗": 8,
  "肃": 8,
  "股": 8,
  "肤": 8,
  "肥": 8,
  "肩": 8,
  "育": 8,
  "肺": 8,
  "肿": 8,
  "胀": 8,
  "胁": 8,
  "舍": 8,
  "艰": 8,
  "芬": 8,
  "花": 8,
  "芳": 8,
  "苏": 8,
  "虎": 8,
  "表": 8,
  "衫": 8,
  "规": 8,
  "视": 8,
  "试": 8,
  "诚": 8,
  "话": 8,
  "诞": 8,
  "询": 8,
  "该": 8,
  "详": 8,
  "责": 8,
  "贤": 8,
  "账": 8,
  "质": 8,
  "贪": 8,
  "贫": 8,
  "购": 8,
  "贯": 8,
  "转": 8,
  "轮": 8,
  "软": 8,
  "轰": 8,
  "迎": 8,
  "近": 8,
  "还": 8,
  "这": 8,
  "连": 8,
  "迫": 8,
  "采": 8,
  "金": 8,
  "钓": 8,
  "闹": 8,
  "阿": 8,
  "陈": 8,
  "陌": 8,
  "陕": 8,
  "隶": 8,
  "雨": 8,
  "青": 8,
  "非": 8,
  "饰": 8,
  "饱": 8,
  "饲": 8,
  "驶": 8,
  "驻": 8,
  "驾": 8,
  "鸣": 8,
  "齿": 8,
  "举": 9,
  "亭": 9,
  "亲": 9,
  "侯": 9,
  "侵": 9,
  "便": 9,
  "促": 9,
  "俊": 9,
  "俗": 9,
  "俘": 9,
  "保": 9,
  "信": 9,
  "俩": 9,
  "兹": 9,
  "冒": 9,
  "冠": 9,
  "削": 9,
  "前": 9,
  "勃": 9,
  "勇": 9,
  "勉": 9,
  "南": 9,
  "厘": 9,
  "厚": 9,
  "叙": 9,
  "叛": 9,
  "咬": 9,
  "咱": 9,
  "咽": 9,
  "哀": 9,
  "品": 9,
  "响": 9,
  "哪": 9,
  "型": 9,
  "城": 9,
  "复": 9,
  "奏": 9,
  "契": 9,
  "奖": 9,
  "姨": 9,
  "姻": 9,
  "姿": 9,
  "威": 9,
  "娃": 9,
  "娇": 9,
  "娜": 9,
  "孩": 9,
  "客": 9,
  "宪": 9,
  "尝": 9,
  "屏": 9,
  "峡": 9,
  "帝": 9,
  "带": 9,
  "幽": 9,
  "度": 9,
  "建": 9,
  "弯": 9,
  "待": 9,
  "很": 9,
  "律": 9,
  "怎": 9,
  "怒": 9,
  "思": 9,
  "急": 9,
  "怨": 9,
  "总": 9,
  "恒": 9,
  "恢": 9,
  "恨": 9,
  "恰": 9,
  "恼": 9,
  "战": 9,
  "扁": 9,
  "拜": 9,
  "拼": 9,
  "拾": 9,
  "持": 9,
  "挂": 9,
  "指": 9,
  "按": 9,
  "挑": 9,
  "挖": 9,
  "挡": 9,
  "挣": 9,
  "挤": 9,
  "挪": 9,
  "挺": 9,
  "政": 9,
  "故": 9,
  "施": 9,
  "星": 9,
  "映": 9,
  "昨": 9,
  "昭": 9,
  "是": 9,
  "显": 9,
  "枯": 9,
  "柄": 9,
  "柏": 9,
  "某": 9,
  "染": 9,
  "柔": 9,
  "查": 9,
  "柯": 9,
  "柱": 9,
  "柳": 9,
  "标": 9,
  "栏": 9,
  "树": 9,
  "歪": 9,
  "残": 9,
  "段": 9,
  "泉": 9,
  "洁": 9,
  "洒": 9,
  "洗": 9,
  "洞": 9,
  "津": 9,
  "洪": 9,
  "活": 9,
  "派": 9,
  "济": 9,
  "浑": 9,
  "浓": 9,
  "点": 9,
  "炼": 9,
  "烂": 9,
  "牲": 9,
  "牵": 9,
  "狠": 9,
  "独": 9,
  "狭": 9,
  "狮": 9,
  "狱": 9,
  "玲": 9,
  "玻": 9,
  "珍": 9,
  "界": 9,
  "畏": 9,
  "疫": 9,
  "疯": 9,
  "皆": 9,
  "盆": 9,
  "盈": 9,
  "相": 9,
  "盼": 9,
  "盾": 9,
  "省": 9,
  "眉": 9,
  "看": 9,
  "砍": 9,
  "研": 9,
  "秋": 9,
  "种": 9,
  "科": 9,
  "秒": 9,
  "突": 9,
  "窃": 9,
  "类": 9,
  "结": 9,
  "绕": 9,
  "绘": 9,
  "给": 9,
  "络": 9,
  "绝": 9,
  "统": 9,
  "罚": 9,
  "美": 9,
  "者": 9,
  "耍": 9,
  "耐": 9,
  "耶": 9,
  "胃": 9,
  "胆": 9,
  "胎": 9,
  "胖": 9,
  "胞": 9,
  "脉": 9,
  "致": 9,
  "苗": 9,
  "若": 9,
  "苦": 9,
  "英": 9,
  "茨": 9,
  "茫": 9,
  "荡": 9,
  "药": 9,
  "虹": 9,
  "虽": 9,
  "要": 9,
  "览": 9,
  "觉": 9,
  "语": 9,
  "诱": 9,
  "说": 9,
  "贴": 9,
  "贷": 9,
  "贸": 9,
  "费": 9,
  "贺": 9,
  "赴": 9,
  "赵": 9,
  "轻": 9,
  "迪": 9,
  "述": 9,
  "迹": 9,
  "逊": 9,
  "郁": 9,
  "郎": 9,
  "郑": 9,
  "郡": 9,
  "重": 9,
  "钢": 9,
  "钦": 9,
  "钩": 9,
  "阁": 9,
  "限": 9,
  "院": 9,
  "险": 9,
  "面": 9,
  "革": 9,
  "音": 9,
  "项": 9,
  "须": 9,
  "食": 9,
  "饶": 9,
  "首": 9,
  "骂": 9,
  "骄": 9,
  "乘": 10,
  "俯": 10,
  "俱": 10,
  "倍": 10,
  "倒": 10,
  "倘": 10,
  "候": 10,
  "倡": 10,
  "债": 10,
  "值": 10,
  "倾": 10,
  "党": 10,
  "兼": 10,
  "准": 10,
  "凉": 10,
  "凌": 10,
  "剥": 10,
  "匪": 10,
  "卿": 10,
  "原": 10,
  "哦": 10,
  "哩": 10,
  "哭": 10,
  "哲": 10,
  "哼": 10,
  "唇": 10,
  "唉": 10,
  "唤": 10,
  "圆": 10,
  "埃": 10,
  "埋": 10,
  "夏": 10,
  "套": 10,
  "宰": 10,
  "害": 10,
  "宴": 10,
  "家": 10,
  "容": 10,
  "宾": 10,
  "将": 10,
  "展": 10,
  "峰": 10,
  "弱": 10,
  "徐": 10,
  "徒": 10,
  "恋": 10,
  "恭": 10,
  "息": 10,
  "恳": 10,
  "悄": 10,
  "悔": 10,
  "悟": 10,
  "悦": 10,
  "扇": 10,
  "拳": 10,
  "拿": 10,
  "挨": 10,
  "振": 10,
  "挽": 10,
  "捉": 10,
  "捐": 10,
  "捕": 10,
  "效": 10,
  "敌": 10,
  "料": 10,
  "晃": 10,
  "晋": 10,
  "晓": 10,
  "晕": 10,
  "朗": 10,
  "柴": 10,
  "校": 10,
  "样": 10,
  "根": 10,
  "格": 10,
  "桂": 10,
  "桃": 10,
  "框": 10,
  "案": 10,
  "桌": 10,
  "桑": 10,
  "档": 10,
  "桥": 10,
  "殊": 10,
  "氧": 10,
  "泰": 10,
  "流": 10,
  "浙": 10,
  "浦": 10,
  "浩": 10,
  "浪": 10,
  "浮": 10,
  "浴": 10,
  "海": 10,
  "涂": 10,
  "消": 10,
  "涉": 10,
  "涌": 10,
  "涛": 10,
  "润": 10,
  "涨": 10,
  "烦": 10,
  "烧": 10,
  "热": 10,
  "爱": 10,
  "爹": 10,
  "特": 10,
  "牺": 10,
  "狼": 10,
  "珠": 10,
  "瓶": 10,
  "瓷": 10,
  "留": 10,
  "畜": 10,
  "疲": 10,
  "疼": 10,
  "疾": 10,
  "病": 10,
  "症": 10,
  "皱": 10,
  "益": 10,
  "盐": 10,
  "真": 10,
  "眠": 10,
  "矩": 10,
  "破": 10,
  "础": 10,
  "祖": 10,
  "祝": 10,
  "神": 10,
  "租": 10,
  "秦": 10,
  "秩": 10,
  "称": 10,
  "窄": 10,
  "站": 10,
  "竞": 10,
  "笑": 10,
  "粉": 10,
  "素": 10,
  "紧": 10,
  "继": 10,
  "罢": 10,
  "羞": 10,
  "翁": 10,
  "翅": 10,
  "耕": 10,
  "耗": 10,
  "耸": 10,
  "耻": 10,
  "胶": 10,
  "胸": 10,
  "能": 10,
  "脂": 10,
  "脆": 10,
  "脊": 10,
  "脏": 10,
  "脑": 10,
  "臭": 10,
  "般": 10,
  "舱": 10,
  "艳": 10,
  "茶": 10,
  "荒": 10,
  "荷": 10,
  "莉": 10,
  "莱": 10,
  "莲": 10,
  "获": 10,
  "衰": 10,
  "衷": 10,
  "袁": 10,
  "袖": 10,
  "请": 10,
  "诸": 10,
  "课": 10,
  "谁": 10,
  "调": 10,
  "谅": 10,
  "谈": 10,
  "谊": 10,
  "贼": 10,
  "贾": 10,
  "资": 10,
  "起": 10,
  "较": 10,
  "辱": 10,
  "迷": 10,
  "送": 10,
  "适": 10,
  "逆": 10,
  "选": 10,
  "透": 10,
  "递": 10,
  "途": 10,
  "逝": 10,
  "部": 10,
  "钱": 10,
  "钻": 10,
  "铃": 10,
  "阅": 10,
  "除": 10,
  "陪": 10,
  "陵": 10,
  "陷": 10,
  "难": 10,
  "顽": 10,
  "预": 10,
  "饿": 10,
  "验": 10,
  "骨": 10,
  "高": 10,
  "鬼": 10,
  "鸭": 10,
  "乾": 11,
  "假": 11,
  "偏": 11,
  "做": 11,
  "停": 11,
  "偶": 11,
  "偷": 11,
  "偿": 11,
  "兽": 11,
  "凑": 11,
  "剪": 11,
  "售": 11,
  "唯": 11,
  "唱": 11,
  "商": 11,
  "啥": 11,
  "啦": 11,
  "啸": 11,
  "圈": 11,
  "培": 11,
  "基": 11,
  "堆": 11,
  "堵": 11,
  "够": 11,
  "婆": 11,
  "婴": 11,
  "宽": 11,
  "宿": 11,
  "寂": 11,
  "寄": 11,
  "密": 11,
  "尉": 11,
  "崇": 11,
  "崖": 11,
  "崩": 11,
  "巢": 11,
  "常": 11,
  "庸": 11,
  "弹": 11,
  "彩": 11,
  "得": 11,
  "悉": 11,
  "悠": 11,
  "患": 11,
  "悬": 11,
  "情": 11,
  "惊": 11,
  "惜": 11,
  "惟": 11,
  "惧": 11,
  "惨": 11,
  "惯": 11,
  "据": 11,
  "捷": 11,
  "掏": 11,
  "排": 11,
  "掘": 11,
  "掠": 11,
  "接": 11,
  "推": 11,
  "掩": 11,
  "措": 11,
  "描": 11,
  "敏": 11,
  "教": 11,
  "斜": 11,
  "断": 11,
  "旋": 11,
  "族": 11,
  "晚": 11,
  "晨": 11,
  "曹": 11,
  "曼": 11,
  "望": 11,
  "梁": 11,
  "梅": 11,
  "梯": 11,
  "械": 11,
  "欲": 11,
  "液": 11,
  "淋": 11,
  "淡": 11,
  "淫": 11,
  "淮": 11,
  "深": 11,
  "混": 11,
  "添": 11,
  "清": 11,
  "渊": 11,
  "渔": 11,
  "猎": 11,
  "猛": 11,
  "猜": 11,
  "率": 11,
  "球": 11,
  "理": 11,
  "甜": 11,
  "痕": 11,
  "盒": 11,
  "盖": 11,
  "盗": 11,
  "盘": 11,
  "眼": 11,
  "睁": 11,
  "硕": 11,
  "祥": 11,
  "祭": 11,
  "祸": 11,
  "离": 11,
  "章": 11,
  "符": 11,
  "第": 11,
  "笼": 11,
  "粒": 11,
  "粗": 11,
  "粘": 11,
  "累": 11,
  "绩": 11,
  "绪": 11,
  "续": 11,
  "绳": 11,
  "维": 11,
  "绵": 11,
  "综": 11,
  "绿": 11,
  "聊": 11,
  "职": 11,
  "脖": 11,
  "脸": 11,
  "船": 11,
  "莎": 11,
  "菌": 11,
  "萄": 11,
  "萍": 11,
  "萨": 11,
  "虚": 11,
  "蛇": 11,
  "蛋": 11,
  "袋": 11,
  "被": 11,
  "袭": 11,
  "谎": 11,
  "跃": 11,
  "辅": 11,
  "辆": 11,
  "通": 11,
  "速": 11,
  "造": 11,
  "逢": 11,
  "逻": 11,
  "郭": 11,
  "铜": 11,
  "铭": 11,
  "阐": 11,
  "陶": 11,
  "随": 11,
  "隐": 11,
  "雪": 11,
  "领": 11,
  "颇": 11,
  "颈": 11,
  "馆": 11,
  "骑": 11,
  "鸿": 11,
  "鹿": 11,
  "麻": 11,
  "黄": 11,
  "傅": 12,
  "储": 12,
  "傲": 12,
  "剩": 12,
  "割": 12,
  "厦": 12,
  "厨": 12,
  "喂": 12,
  "喃": 12,
  "喉": 12,
  "喊": 12,
  "喘": 12,
  "喜": 12,
  "喷": 12,
  "喻": 12,
  "堡": 12,
  "堪": 12,
  "塔": 12,
  "媒": 12,
  "媚": 12,
  "嫂": 12,
  "寒": 12,
  "寓": 12,
  "尊": 12,
  "就": 12,
  "属": 12,
  "屠": 12,
  "帽": 12,
  "幅": 12,
  "廊": 12,
  "强": 12,
  "彭": 12,
  "御": 12,
  "循": 12,
  "悲": 12,
  "惑": 12,
  "惠": 12,
  "惩": 12,
  "愉": 12,
  "愣": 12,
  "愤": 12,
  "愧": 12,
  "慌": 12,
  "慨": 12,
  "提": 12,
  "插": 12,
  "握": 12,
  "揭": 12,
  "援": 12,
  "搜": 12,
  "搭": 12,
  "敦": 12,
  "斑": 12,
  "斯": 12,
  "普": 12,
  "晰": 12,
  "晴": 12,
  "晶": 12,
  "暂": 12,
  "曾": 12,
  "替": 12,
  "最": 12,
  "朝": 12,
  "期": 12,
  "棉": 12,
  "棋": 12,
  "棍": 12,
  "棒": 12,
  "森": 12,
  "棵": 12,
  "椅": 12,
  "植": 12,
  "欺": 12,
  "殖": 12,
  "渡": 12,
  "渴": 12,
  "游": 12,
  "湘": 12,
  "湿": 12,
  "溃": 12,
  "滋": 12,
  "滞": 12,
  "焦": 12,
  "焰": 12,
  "然": 12,
  "牌": 12,
  "猩": 12,
  "猪": 12,
  "猫": 12,
  "猴": 12,
  "琴": 12,
  "琼": 12,
  "番": 12,
  "疏": 12,
  "盛": 12,
  "着": 12,
  "硬": 12,
  "确": 12,
  "禅": 12,
  "稀": 12,
  "程": 12,
  "稍": 12,
  "窗": 12,
  "窝": 12,
  "童": 12,
  "等": 12,
  "筋": 12,
  "筑": 12,
  "筒": 12,
  "答": 12,
  "紫": 12,
  "缓": 12,
  "缘": 12,
  "翔": 12,
  "联": 12,
  "脾": 12,
  "腊": 12,
  "腔": 12,
  "舒": 12,
  "艇": 12,
  "菜": 12,
  "菩": 12,
  "菲": 12,
  "萧": 12,
  "落": 12,
  "蒋": 12,
  "蛮": 12,
  "街": 12,
  "裁": 12,
  "裂": 12,
  "装": 12,
  "裕": 12,
  "裤": 12,
  "象": 12,
  "赋": 12,
  "赌": 12,
  "赏": 12,
  "赐": 12,
  "赔": 12,
  "趁": 12,
  "越": 12,
  "趋": 12,
  "跌": 12,
  "距": 12,
  "践": 12,
  "辈": 12,
  "辉": 12,
  "逮": 12,
  "遍": 12,
  "都": 12,
  "量": 12,
  "铺": 12,
  "链": 12,
  "锁": 12,
  "锅": 12,
  "锋": 12,
  "锐": 12,
  "阔": 12,
  "隆": 12,
  "隔": 12,
  "雄": 12,
  "雅": 12,
  "集": 12,
  "雇": 12,
  "韩": 12,
  "骗": 12,
  "骚": 12,
  "鹅": 12,
  "黑": 12,
  "催": 13,
  "傻": 13,
  "像": 13,
  "勤": 13,
  "叠": 13,
  "嗯": 13,
  "塑": 13,
  "塞": 13,
  "填": 13,
  "嫁": 13,
  "嫌": 13,
  "幕": 13,
  "廉": 13,
  "微": 13,
  "想": 13,
  "惹": 13,
  "愁": 13,
  "愈": 13,
  "意": 13,
  "愚": 13,
  "感": 13,
  "慈": 13,
  "慎": 13,
  "搞": 13,
  "搬": 13,
  "携": 13,
  "摄": 13,
  "摆": 13,
  "摊": 13,
  "敬": 13,
  "数": 13,
  "新": 13,
  "暖": 13,
  "歇": 13,
  "殿": 13,
  "毁": 13,
  "源": 13,
  "溜": 13,
  "溪": 13,
  "溶": 13,
  "滑": 13,
  "滚": 13,
  "滥": 13,
  "滩": 13,
  "漠": 13,
  "煌": 13,
  "煞": 13,
  "煤": 13,
  "照": 13,
  "献": 13,
  "瑞": 13,
  "瑟": 13,
  "痴": 13,
  "盟": 13,
  "矮": 13,
  "碍": 13,
  "碎": 13,
  "碑": 13,
  "碗": 13,
  "碰": 13,
  "稣": 13,
  "筹": 13,
  "签": 13,
  "粮": 13,
  "缝": 13,
  "缠": 13,
  "罩": 13,
  "置": 13,
  "群": 13,
  "聘": 13,
  "腰": 13,
  "腹": 13,
  "腺": 13,
  "腾": 13,
  "腿": 13,
  "营": 13,
  "葛": 13,
  "葡": 13,
  "董": 13,
  "葬": 13,
  "蒂": 13,
  "蓄": 13,
  "蜂": 13,
  "裸": 13,
  "解": 13,
  "触": 13,
  "誉": 13,
  "谨": 13,
  "赖": 13,
  "跟": 13,
  "跨": 13,
  "跪": 13,
  "路": 13,
  "躲": 13,
  "辑": 13,
  "辞": 13,
  "辟": 13,
  "逼": 13,
  "遂": 13,
  "道": 13,
  "遥": 13,
  "酬": 13,
  "鉴": 13,
  "错": 13,
  "锡": 13,
  "锦": 13,
  "键": 13,
  "障": 13,
  "零": 13,
  "雷": 13,
  "雾": 13,
  "频": 13,
  "鲍": 13,
  "鹏": 13,
  "鼓": 13,
  "鼠": 13,
  "龄": 13,
  "僚": 14,
  "僧": 14,
  "嘉": 14,
  "嘛": 14,
  "境": 14,
  "墓": 14,
  "墙": 14,
  "察": 14,
  "寡": 14,
  "愿": 14,
  "慕": 14,
  "截": 14,
  "摔": 14,
  "摘": 14,
  "摧": 14,
  "摸": 14,
  "敲": 14,
  "旗": 14,
  "歉": 14,
  "歌": 14,
  "满": 14,
  "滴": 14,
  "漂": 14,
  "漆": 14,
  "漏": 14,
  "漫": 14,
  "熊": 14,
  "璃": 14,
  "疑": 14,
  "碧": 14,
  "磁": 14,
  "福": 14,
  "稳": 14,
  "竭": 14,
  "算": 14,
  "管": 14,
  "粹": 14,
  "精": 14,
  "缩": 14,
  "署": 14,
  "翠": 14,
  "聚": 14,
  "腐": 14,
  "膀": 14,
  "膜": 14,
  "舞": 14,
  "蒙": 14,
  "蓝": 14,
  "蔽": 14,
  "蜜": 14,
  "誓": 14,
  "谭": 14,
  "谱": 14,
  "豪": 14,
  "貌": 14,
  "赚": 14,
  "赛": 14,
  "赫": 14,
  "辖": 14,
  "遣": 14,
  "遭": 14,
  "遮": 14,
  "酷": 14,
  "酸": 14,
  "需": 14,
  "颗": 14,
  "魂": 14,
  "鼻": 14,
  "嘱": 15,
  "增": 15,
  "墨": 15,
  "履": 15,
  "影": 15,
  "德": 15,
  "慧": 15,
  "慰": 15,
  "懂": 15,
  "摩": 15,
  "撑": 15,
  "撒": 15,
  "撞": 15,
  "撤": 15,
  "播": 15,
  "撰": 15,
  "暴": 15,
  "模": 15,
  "横": 15,
  "毅": 15,
  "潘": 15,
  "潜": 15,
  "潮": 15,
  "澳": 15,
  "熟": 15,
  "璇": 15,
  "瘤": 15,
  "瘦": 15,
  "稿": 15,
  "箭": 15,
  "箱": 15,
  "篇": 15,
  "糊": 15,
  "聪": 15,
  "艘": 15,
  "蔡": 15,
  "蝶": 15,
  "豫": 15,
  "趣": 15,
  "踏": 15,
  "踪": 15,
  "躺": 15,
  "遵": 15,
  "醉": 15,
  "震": 15,
  "鞋": 15,
  "题": 15,
  "颜": 15,
  "飘": 15,
  "黎": 15,
  "儒": 16,
  "凝": 16,
  "嘴": 16,
  "器": 16,
  "壁": 16,
  "憾": 16,
  "懒": 16,
  "操": 16,
  "整": 16,
  "燃": 16,
  "燕": 16,
  "磨": 16,
  "禧": 16,
  "穆": 16,
  "糖": 16,
  "缴": 16,
  "翰": 16,
  "薪": 16,
  "融": 16,
  "衡": 16,
  "赞": 16,
  "赠": 16,
  "辨": 16,
  "辩": 16,
  "邀": 16,
  "醒": 16,
  "镜": 16,
  "雕": 16,
  "霍": 16,
  "颠": 16,
  "餐": 16,
  "默": 16,
  "徽": 17,
  "戴": 17,
  "擦": 17,
  "爵": 17,
  "癌": 17,
  "瞧": 17,
  "瞪": 17,
  "瞬": 17,
  "糟": 17,
  "繁": 17,
  "翼": 17,
  "臂": 17,
  "薄": 17,
  "薛": 17,
  "赢": 17,
  "霞": 17,
  "骤": 17,
  "翻": 18,
  "藤": 18,
  "鞭": 18,
  "魏": 18,
  "鹰": 18,
  "爆": 19,
  "疆": 19,
  "警": 19,
  "颤": 19,
  "嚷": 20,
  "籍": 20,
  "耀": 20,
  "魔": 20,
  "灌": 21,
  "蠢": 21,
  "霸": 21,
  "囊": 22
};

export function getCharacterStrokeCount(title: string) {
  return characterStrokeCounts[title] ?? 999;
}
